module.exports = "/images/879820c-wohler.png";